import * as React from "react";

const ClipboardIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M9.99998 7.33334H8.66665C8.31302 7.33334 7.97389 7.47382 7.72384 7.72387C7.47379 7.97392 7.33331 8.31305 7.33331 8.66668V16.6667C7.33331 17.0203 7.47379 17.3594 7.72384 17.6095C7.97389 17.8595 8.31302 18 8.66665 18H15.3333C15.6869 18 16.0261 17.8595 16.2761 17.6095C16.5262 17.3594 16.6666 17.0203 16.6666 16.6667V8.66668C16.6666 8.31305 16.5262 7.97392 16.2761 7.72387C16.0261 7.47382 15.6869 7.33334 15.3333 7.33334H14"
                stroke="#2D3435"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99998 7.33333C9.99998 6.97971 10.1405 6.64057 10.3905 6.39052C10.6406 6.14048 10.9797 6 11.3333 6H12.6667C13.0203 6 13.3594 6.14048 13.6095 6.39052C13.8595 6.64057 14 6.97971 14 7.33333C14 7.68696 13.8595 8.02609 13.6095 8.27614C13.3594 8.52619 13.0203 8.66667 12.6667 8.66667H11.3333C10.9797 8.66667 10.6406 8.52619 10.3905 8.27614C10.1405 8.02609 9.99998 7.68696 9.99998 7.33333Z"
                stroke="#2D3435"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99998 12H14"
                stroke="#2D3435"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99998 14.6667H14"
                stroke="#2D3435"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(ClipboardIcon);
